module.exports = "<svg class=\"t-icon t-icon--{{name}} {{iconClass}} {{additionalcss}}\"><use xlink:href=\"{{base}}#{{name}}\"></use></svg>\n";
